var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoloSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55 57.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#af975c;opacity:0;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#facfaf;}.cls-5{fill:#ced5dc;}.cls-6{fill:#acb3b9;}.cls-7{fill:#f8b64b;}.cls-8{fill:#415a6b;opacity:0.1;}.cls-9{fill:#1a313a;}.cls-10{fill:#3a3e36;}.cls-11{fill:#ffe3ba;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.5,
    cy: 27.5,
    r: 27.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solo_round_selected",
    "data-name": "solo round selected"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.6,36.06l-.92,1a4.45,4.45,0,0,1-3.28,1.45H27a4.45,4.45,0,0,1-3.28-1.45l-.92-1A18.81,18.81,0,0,1,21.18,34v3.78h0l0,.07a8,8,0,0,0,12.9,0l.06-.07v0h0V34a17.9,17.9,0,0,1-1.62,2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.51,50.3v6.76H3.88V50.3A9,9,0,0,1,9.8,41.87l11.37-4.09h0a.16.16,0,0,0,.05.07,8,8,0,0,0,12.9,0s0,0,.06-.07h0l11.35,4.09a9,9,0,0,1,5.94,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.71,41.36h0v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.71,41.35v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.22,37.78c-.08.11-.09.11,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.68,37.07a4.9,4.9,0,0,1-3.28,1.45H27a4.14,4.14,0,0,1-.87-.09,4.89,4.89,0,0,1-.68-.21l-.13,0a4.52,4.52,0,0,1-1.41-.94h0l4.28,3.82h0A5.56,5.56,0,0,0,29,41h0c.26,0,.52-.1.78-.17l.09,0a6.51,6.51,0,0,0,.71-.23l.16-.07a4.78,4.78,0,0,0,.61-.28l.24-.13a5.33,5.33,0,0,0,.51-.31l.31-.22c.14-.1.28-.2.41-.31s.26-.24.39-.37l.28-.26a8.89,8.89,0,0,0,.61-.74l.06-.07v0h0V34h0a17.9,17.9,0,0,1-1.62,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.19,37.78c.08.11.07.11,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.7,39.1l0,0a10,10,0,0,0,16.06-.07,2.11,2.11,0,0,0,.3-.6l-1.86-.67h0s-.05.07-.06.07a8,8,0,0,1-12.9,0l0-.07h0l-1.84.67a2.05,2.05,0,0,0,.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37,24.74c0,.19.07.37.1.55C37,25.11,37,24.93,37,24.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.88,24.32l.06.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.48,22.48l0-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.14,25.87a1.5,1.5,0,0,1,0,.2A1.5,1.5,0,0,0,37.14,25.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.08,25.46c0,.09,0,.17,0,.24S37.1,25.55,37.08,25.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.53,22.7a2,2,0,0,1,0,.24A2,2,0,0,0,36.53,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.12,23.72l0,.13-.9,2.53a.43.43,0,0,1,0-.05,18.87,18.87,0,0,1-.39,2,3.2,3.2,0,0,0,1.6-2.72A4,4,0,0,0,38.12,23.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.78,23.84l.06.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.64,23.17c0,.15.06.29.09.45C36.7,23.46,36.67,23.32,36.64,23.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M17.3,23.66l.92,2.72s-.41-8.3,2.72-8.38c0,0,4.64,1.86,6.83,2.39,0,0,4.71.59,7.17-2.31a2.88,2.88,0,0,1,1.27,3.27,38.41,38.41,0,0,1,1,5l.9-2.53c.43-1.3,2.08-7.22-2.69-8.68,0,0-.38-5.43-8-6.1,0,0-5.67-.3-10.28,6.1l1.11-.44S16,16.07,17.3,23.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.22,26.29v.09l-.92-2.72A3.92,3.92,0,0,0,17,25.57a3.2,3.2,0,0,0,1.6,2.72A19.12,19.12,0,0,1,18.22,26.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.21,21.35a2.88,2.88,0,0,0-1.27-3.27c-2.46,2.9-7.17,2.31-7.17,2.31C25.58,19.86,20.94,18,20.94,18c-2.93.07-2.75,7.38-2.72,8.29a18.11,18.11,0,0,0,4.58,9.77l.92,1A4.45,4.45,0,0,0,27,38.52h1.4a4.45,4.45,0,0,0,3.28-1.45l.92-1a18.16,18.16,0,0,0,4.57-9.73A39.34,39.34,0,0,0,36.21,21.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.52,15.23,35.37,15c0,.09,0,.15,0,.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoloSelected);
export default __webpack_public_path__ + "static/media/icon_solo_selected.e14589b7b49751e3caa029aa9c69f3e7.svg";
export { ForwardRef as ReactComponent };